<template>
  <div class="main-form">
    <div class="content-form-customer">
      <el-row
        type="flex"
        justify="center">
        <el-col :span="20">
          <div class="steps">
            <el-steps
              :active="active"
              align-center
              finish-status="success">
              <el-step title="Datos generales"/>
              <el-step title="Contacto"/>
              <el-step title="Actividades"/>
            </el-steps>
          </div>
        </el-col>
      </el-row>
      <el-form
        ref="formClient"
        :model="model"
        :rules="rules"
        label-position="top"
        class="client-form">
        <div
          v-if="active === 0"
          :key="1"
          class="general-data">
          <el-row
            :gutter="10">
            <el-col :span="12">
              <el-form-item
                label="Nombre"
                prop="firstName"
              >
                <el-input v-model="model.firstName"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Apellidos"
                prop="lastName"
              >
                <el-input v-model="model.lastName"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            :gutter="10"
            type="flex">
            <el-col :span="12">
              <el-form-item
                label="Compañia"
                prop="company">
                <el-input v-model="model.company"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Correo electrónico"
                prop="email">
                <el-input
                  v-model="model.email"
                  type="email"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            :gutter="10">
            <el-col :span="7">
              <el-form-item
                label="Teléfono"
                prop="phone">
                <el-input v-model="model.phone"/>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item
                label="Teléfono de oficina"
                prop="workNumber">
                <el-input v-model="model.workNumber"/>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item
                label="Extensión"
                prop="workExtension">
                <el-input v-model="model.workExtension"/>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item
                label="Celular"
                prop="mobile">
                <el-input v-model="model.mobile"/>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div
          v-if="active === 1"
          :key="2"
          class="contact-data">
          <el-row
            :gutter="10"
            type="flex"
            justify="center">
            <el-col :span="12">
              <el-form-item
                label="Calle"
                prop="street">
                <el-input v-model="model.street"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="Exterior"
                prop="outdoor">
                <el-input v-model="model.outdoor"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="Interior"
                prop="indoorNumber">
                <el-input v-model.number="model.indoorNumber"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            :gutter="10"
            type="flex"
            justify="center">
            <el-col :span="8">
              <el-form-item
                label="Pais"
                prop="country">
                <el-select
                  v-model="model.country"
                  placeholder="Seleccione el país">
                  <el-option
                    v-for="item in countries"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="Código Postal"
                prop="zipCode">
                <el-input
                  v-debounce:1s="syncAddress"
                  v-model="oldZipCode"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="Estado"
                prop="state">
                <el-input
                  v-model="model.state"
                  disabled/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            :gutter="10"
            type="flex"
            justify="center">
            <el-col :span="12">
              <el-form-item
                label="Municipio"
                prop="municipality">
                <el-input
                  v-model="model.municipality"
                  disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Colonia"
                prop="neighborhood">
                <el-autocomplete
                  v-model="model.neighborhood"
                  :fetch-suggestions="fetchNeighborhoods"
                  placeholder="Escriba la colonia"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div
          v-if="active === 2"
          :key="3"
          class="customer-activity">
          <el-row :gutter="15">
            <el-col :span="24">
              <h5>Elja una opcion de las siguientes categorias.</h5>
              <span>Nota:<strong> Para ver los campos de la categoría debe de dar click en la flecha</strong></span>
            </el-col>
          </el-row>
          <el-row>
            <customer-activities
              :old-customer="old"
              @listActivity="activitiesSelected"/>
          </el-row>
        </div>
      </el-form>
    </div>
    <div class="actions-button">
      <el-button
        v-if="active > 0"
        @click="backStep">
        Atras
      </el-button>
      <el-button
        v-if="active !== 2"
        @click="validateStep('formClient')">
        Siguiente
      </el-button>
      <el-button
        v-if="active === 2"
        @click="onSubmit">
        Finalizar
      </el-button>
    </div>
  </div>
</template>

<script>
import Client from '@/models/customers/customers-model'
import { mapActions } from 'vuex'
import http from '@/services/http.service'
import CustomerActivities from './customers-activities'

export default {
  name: 'CustomersForm',
  components: {
    CustomerActivities
  },
  props: {
    old: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      model: Client.model(),
      rules: Client.rules(),
      active: 0,
      isValidated: false,
      zipCodeEnable: true,
      country: '',
      countries: [
        {
          value: 'ESTADOS UNIDOS',
          label: 'Estados Unidos'
        },
        {
          value: 'MÉXICO',
          label: 'México'
        }
      ],
      activities: [],
      oldActivities: [],
      fullscreenLoading: false,
      oldZipCode: ''
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  mounted () {
    if (this.old.id !== undefined) {
      this.model = Object.assign({}, this.model, this.old)
      this.syncAddress(this.old.zipCode)
      this.oldZipCode = this.old.zipCode
    } else {
      this.model.country = 'MÉXICO'
    }
  },
  methods: {
    ...mapActions('customers', ['save']),
    ...mapActions('customerActivities', {'saveActivities': 'save'}),
    fetchNeighborhoods (queryString, cb) {
      let results = []
      if (this.model.zipCode) {
        http.get('zip-codes', {params: {
          'filters[where][code][eq]': this.model.zipCode,
          'filters[where][township][contains]': queryString
        }}).then(({data}) => {
          for (let item of data.items) {
            results.push({
              label: item.township,
              value: item.township
            })
          }
          cb(results)
        })
      } else {
        let arr = []
        cb(arr)
      }
    },
    syncAddress (value) {
      if (this.old !== undefined) {
        window.clearTimeout(this.timeoutInstance)
        this.timeoutInstance = window.setTimeout(() => {
          this.model.state = 'Sincronizando'
          this.model.municipality = 'Sincronizando'
          if (value.trim() && !isNaN(value.trim())) {
            http
              .get(process.env.API_URL + 'zip-codes?filters[where][code][eq]=' + value + '&filters[where][country][eq]=' + this.model.country)
              .then(response => {
                this.model.zipCode = response.data.items[0].code.toString()
                this.model.state = response.data.items[0].state
                this.model.municipality = response.data.items[0].municipality
              })
              .catch(error => {
                this.model.state = 'Código postal no encontrado'
                this.model.municipality = 'Código postal no encontrado'
                return Promise.reject(error)
              })
          } else {
            this.model.neighborhood = ''
            this.model.zipCode = null
            this.model.state = 'Código postal no encontrado'
            this.model.municipality = 'Código postal no encontrado'
          }
        }, 500)
      }
    },
    validateStep (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.active++ > 2) this.active = 0
        }
      })
    },
    backStep () {
      if (this.active === 0) {
        this.active = 0
      } else {
        this.active--
      }
    },
    onSubmit () {
      this.$refs['formClient'].validate((valid) => {
        if (valid) {
          this.model.favourite = false
          this.model.userId = this.profile.id
          if (this.old !== null) {
            this.model.id = this.old.id
            delete this.model.isActive
          }
          this.save(this.model).then(response => {
            for (let activity of this.activities) {
              let model = {
                activityId: activity.activity,
                customerId: response.data.id,
                surface: parseFloat(activity.surface)
              }
              if (!this.old) {
                this.saveActivities(model).then(res => {
                  this.$store.dispatch('customerActivities/query', { 'filters[where][customerId][eq]': response.data.id, with: 'activities' })
                }).catch(error => {
                  console.log(error)
                })
              } else {
                if (activity.remove) {
                  http.delete(`customers/${response.data.id}/activities/${activity.activity}`, {surface: parseFloat(activity.surface)}).then(res => {}).catch(error => {
                    console.log(error)
                  })
                } else {
                  http.put(`customers/${response.data.id}/activities/${activity.activity}`, {surface: parseFloat(activity.surface)}).then(res => {
                    this.$store.dispatch('customerActivities/query', { 'filters[where][customerId][eq]': response.data.id, with: 'activities' })
                  }).catch(error => {
                    console.log(error)
                  })
                }
              }
            }
            this.$emit('onCreate', response.data.id)
          }).catch(error => {
            this.$notify.error({
              group: 'app',
              title: 'Error al crear el cliente.',
              message: 'Por favor, vuelve a intentarlo.'
            })
            return Promise.reject(error)
          })
          this.fullscreenLoading = true
          setTimeout(() => {
            this.fullscreenLoading = false
          }, 2000)
        } else {
          this.$notify.error({
            group: 'app',
            title: 'Verifica el formulario.',
            message: 'Por favor, revisa los errores que se indican dentro del formulario.'
          })
          return false
        }
      })
    },
    activitiesSelected (val) {
      this.activities = val
    }
  }
}
</script>

<style lang="scss" scoped>
  .main-form{
    height: calc(100vh - 150px);
    .content-form-customer{
      height: calc(100% - 40px);
      .steps{
        width: 100%;
        margin: 15px 0;
      }
      label{
        @include font-lato(14px, bold)
      }
      .client-form{
        .el-form-item{
          label{
            @include font-lato(14px, bold)
          }
        }
        .general-data{
          padding: 0 30px;
        }
        .contact-data{
          padding: 0 30px;
        }
        .customer-activity{
          padding: 0 30px;
        }
        .other-activities{
          border: 1px solid $border-primary;
          border-radius: 5px;
          padding: 10px;
          .el-tag{
            margin: 0 5px;
          }
          .input-new-tag{
            width: 90px;
            input{
              border: none;
            }
          }
        }
      }
    }
    .actions-button{
      height: 40px;
      display: flex;
      align-content: flex-end;
      justify-content: flex-end;
      padding: 0 30px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/modules/customers/customers-form.vue